import React from "react"
import ActivityTimelineImage from "../../../../../components/staticQuery/platform/offers/ActivityTimeline"
import P from "../../../../../components/typography/P"
import TimelineGraphic from "../../../../../images/platform/offers/timeline.svg"

const DescriptionText = () => (
  <>
    <P>
      Understanding your best customers is critical to success. We’ll show you
      which Contacts redeem offers and which ones let them expire. Our Timeline
      gives you the tools to dig into Offer activity with ease.
    </P>
  </>
)

const activityTimelineData = {
  titleIcon: TimelineGraphic,
  title: "Activity Timeline",
  description: <DescriptionText />,
  graphic: <ActivityTimelineImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [
    {
      benefitName: "View all Offer Activity",
    },
    {
      benefitName: "See who received your Offer",
    },
    { benefitName: "View when Offers are redeemed" },
    { benefitName: "Check out when Offers expire" },
    { benefitName: "Filter by Date, Activity or Source" },
  ],
}

export default activityTimelineData
